module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_0_null@2x.1d88f3dd.png";